<template>

  <div
  >
    <v-layout  column>

      <v-flex pl-5 pr-5 class="">
        <v-layout  row wrap >

          <v-flex xs12 >
            <form class="mt-2" name="register" autocomplete="nope">

              <div style="overflow: hidden; height: 0px;background: transparent;" data-description="dummyPanel for Chrome auto-fill issue">
                <input type="text" style="height:0;background: transparent; color: transparent;border: none;" data-description="dummyUsername"></input>
                <input type="password" style="height:0;background: transparent; color: transparent;border: none;" data-description="dummyPassword"></input>
              </div>

              <v-text-field
                v-model="email"
                label="E-mail"
                disabled
                class="notranslate"
                append-icon="check"
              ></v-text-field>

              <v-textarea
                v-model="storeDetails"
                label="Store Details"
                disabled
                rows="2"
                class="notranslate"
                append-icon="check"
              ></v-textarea>

              <v-text-field
                v-validate="'required'"
                v-model="fname"
                @blur="checkIfFilled"
                :error-messages="errors.collect('fname')"
                label="First Name"
                data-vv-name="fname"
              ></v-text-field>

              <v-text-field
                v-validate="'required'"
                @blur="checkIfFilled"
                v-model="lname"
                :error-messages="errors.collect('lname')"
                label="Last Name"
                data-vv-name="lname"
              ></v-text-field>

              <v-text-field
                :append-icon="e1 ? 'visibility' : 'visibility_off'"
                @click:append="() => (e1 = !e1)"
                :type="e1 ? 'password' : 'text'"
                @keyup="checkIfFilled"
                hint="At least 8 characters"
                v-validate="'required|min:8'"
                v-model="password"
                :error-messages="errors.collect('password')"
                label="Password"
                class="notranslate"
                data-vv-name="password"
              ></v-text-field>

              <v-flex d-flex xs12>
                <v-btn class="mr-0 ml-0" @click="goBack" color="primary">&#8592; Back</v-btn>
                <v-btn :loading="loading" :disabled="isFormValidated === false"
                       color="success" class="right" @click="register">submit</v-btn>
              </v-flex>

            </form>
          </v-flex>
          <v-flex xs12 >
            <em>By selecting <strong>SUBMIT</strong> you accept the <a target="__blank" href="https://www.cogneti.com/terms-of-use"><strong>Cogneti License</strong></a> terms.</em>
          </v-flex>

        </v-layout>

      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent :width="$store.getters.getAppWidth - 10">
      <!--<v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>-->
      <v-card>
        <v-card-title class="headline">Success</v-card-title>
        <v-card-text>
          <p>Your account created successfully.</p>
          <p>Sign-in info was sent to: <span class="primary--text">{{email}}</span></p>
          <p>(Check junk or firewall filters)</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" to="/login" @click.native="dialog = false">Sign In</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="creationLoaderDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please wait. Your account is being created...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import Vue from 'vue'
import crypto from '../../../../mixins/crypto'
import common from '../../../../mixins/common'
import { mapGetters, mapMutations } from 'vuex'

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
// function compare (a, b) {
//   // Use toUpperCase() to ignore character casing
//   const bandA = a.name.toUpperCase()
//   const bandB = b.name.toUpperCase()
//
//   let comparison = 0
//   if (bandA > bandB) {
//     comparison = 1
//   } else if (bandA < bandB) {
//     comparison = -1
//   }
//   return comparison
// }

function getOS () {
  let userAgent = window.navigator.userAgent
  let platform = window.navigator.platform
  let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
  let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
  let iosPlatforms = ['iPhone', 'iPad', 'iPod']
  let os = 'Desktop'
  // Initially following code return Different OS but for now it will return only iOS, Android and Desktop
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'DESKTOP'
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'IOS'
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'DESKTOP'
  } else if (/Android/.test(userAgent)) {
    os = 'ANDROID'
  } else if (!os && /Linux/.test(platform)) {
    os = 'DESKTOP'
  }
  return os
}

export default {
  name: 'GetNameAndPwd',
  data () {
    return {
      isFormValidated: false,
      storeDetails: '',
      creationLoaderDialog: false,
      loading: false,
      dialog: false,
      fname: '',
      lname: '',
      uname: '',
      e1: true,
      password: '',
      dictionary: {
        attributes: {
          email: 'E-mail Address'
        },
        custom: {
          fname: {
            required: () => 'First Name is required'
          },
          lname: {
            required: () => 'Last Name is required'
          },
          password: {
            required: () => 'Password is required',
            min: 'Your password must be at least 8 characters long'
          }
        }
      }
    }
  },
  created () {
    this.encryptedStr = this.$route.params.email
    this.fname = this.getUserDetails.first_name
    this.lname = this.getUserDetails.last_name
    this.storeDetails = this.getUserDetails.store_details.name + ', ' +
      this.getUserDetails.store_details.address + ', ' +
      this.getUserDetails.store_details.city + ', ' +
      this.getUserDetails.store_details.state + ' ' +
      this.getUserDetails.store_details.zip
  },
  computed: {
    ...mapGetters('registration', ['getUserDetails']),
    email () {
      return this.decryptData(this.getUserDetails.email)
    },
    isAndroid () {
      const userAgent = navigator.userAgent.toLowerCase()
      return userAgent.includes('android')
    },
    otpId () {
      return this.$route.params.otp_id
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    goBack () {
      this.goToSignupStep(this.page, 'store-verification')
    },
    checkIfFilled () {
      this.$validator.validateAll().then((result) => {
        // console.log('checking for form')
        this.isFormValidated = result
      })
    },
    jsonToQueryString (json) {
      return '' +
        Object.keys(json).map(function (key) {
          return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
        }).join('&')
    },
    login () {
      let parameters = {
        grant_type: 'password',
        client_id: process.env.CLIENT_ID,
        client_secret: process.env.CLIENT_SECRET,
        username: this.email,
        password: this.password
      }
      // console.log(this.jsonToQueryString(parameters))
      this.loginLoader = true
      this.$auth.login({
        headers: {
        },
        data: this.jsonToQueryString(parameters),
        rememberMe: this.rememberMe,
        success (res) {
          // this.$store.commit('setAuthToken', this.$auth.token())
          // document.cookie = 'auth_token=' + this.$auth.token() + ';domain=cogneti.com'
          // this.me()
          this.$auth.logout({
            redirect: '/',
            makeRequest: false
          })
        }
      })
    },
    register () {
      // this.loading = true
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.creationLoaderDialog = true
          this.$store.commit('setLoadingDialog', true, { root: true })
          this.$http({
            url: process.env.API_URL + '/ws/userservice/splat/register',
            method: 'POST',
            data: {
              'email': this.email,
              'firstName': this.fname,
              'lastName': this.lname,
              'password': this.password,
              'app': 'WEBADMIN',
              'platform': getOS(),
              'client': this.isAndroid ? 'android' : 'php-client',
              'storeId': this.getUserDetails.store_details.storeId
              // 'otpId': this.getUserDetails.email_otp_id
            }
          }).then((res) => {
            // eslint-disable-next-line no-console
            console.log('Response', res)
            this.uname = res.data.username
            this.creationLoaderDialog = false
            this.$store.commit('setLoadingDialog', false, { root: true })

            this.setUser({
              ...this.getUserDetails,
              welcome: true
            })
            this.dialog = true
          }, error => {
            this.creationLoaderDialog = false
            this.$store.commit('setLoadingDialog', false, { root: true })
            this.$store.commit('flashError', error.message, { root: true })
            this.creationLoaderDialog = false
          }).catch(error => {
            this.creationLoaderDialog = false
            this.$store.commit('setLoadingDialog', false, { root: true })
            this.$store.commit('flashError', error.message, { root: true })
          })
        } else {
          this.creationLoaderDialog = false
        }
      })
    }
  },
  watch: {
    getUserDetails (newVal) {
      this.storeDetails = newVal.store_details.name + ', ' + newVal.store_details.address
    }
  },
  mixins: [crypto, common]
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/sign-up/69/GetNameAndPwd.vue